import { render, staticRenderFns } from "./memberCards.vue?vue&type=template&id=2c928974"
import script from "./memberCards.vue?vue&type=script&lang=js"
export * from "./memberCards.vue?vue&type=script&lang=js"
import style0 from "./memberCards.vue?vue&type=style&index=0&id=2c928974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports